<tdoe-layout logo="/assets/tn-logo.png"
             pageTitle="Tennessee Course Catalog" [flyoutCommands]="[]">
    <main page>
        <h1 class="visually-hidden">Tennessee Course Catalog</h1>
        <router-outlet></router-outlet>
    </main>
    <ng-container footer></ng-container>
</tdoe-layout>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true"><p style="color: white">Loading...</p></ngx-spinner>
